module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-compare-reserve__claim-table"
  }, [_c('p', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "label": "Include In Table"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableFilter),
      expression: "tableFilter"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tableFilter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inside"
    }
  }, [_vm._v("Inside Set Limit")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "outside"
    }
  }, [_vm._v("Outside Set Limit")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "under"
    }
  }, [_vm._v("Under Set Limit")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "over"
    }
  }, [_vm._v("Above Set Limit")])])])], 1), _vm._v(" "), _c('p', [_vm._v("\n        Your results have been further filtered to "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(_vm._s(_vm.tableClaims.length))]), _vm._v("\n        based on your percentile selection.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('table', {
    staticClass: "a-table a-table--full-width"
  }, [_c('thead', [_c('tr', [_vm._m(0), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2",
      "valign": "top"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.fromLabel))])]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2",
      "valign": "top"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.toLabel))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('tbody', _vm._l((_vm.claims), function(claim) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(claim.reference))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(claim.from)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(claim.to)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(claim.claimHandler))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(Math.abs(claim.difference))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.displayPercent(claim.percent)))])])
  }), 0)])]), _vm._v(" "), _c('paginator', {
    attrs: {
      "pageNumbers": _vm.pageNumbers,
      "pageNo": _vm.pageNo
    },
    on: {
      "change": _vm.changePage
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "rowspan": "2",
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("Claim Reference")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "rowspan": "2",
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("Claim Handler")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h2', [_vm._v("Difference")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_c('h2', [_vm._v("£")])]), _vm._v(" "), _c('th', [_c('h2', [_vm._v("%")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-792713bf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/compare/components/ClaimTable.vue
// module id = 1751
// module chunks = 0